import { render, staticRenderFns } from "./return2.vue?vue&type=template&id=fe200c66&scoped=true"
import script from "./return2.vue?vue&type=script&lang=js"
export * from "./return2.vue?vue&type=script&lang=js"
import style0 from "./return2.vue?vue&type=style&index=0&id=fe200c66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe200c66",
  null
  
)

export default component.exports